<template>
    <div
    id="payment-popup"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered modal-lg" >
            <div class="modal-content" style="border:none;">
                <div class="row" style="padding-left:1.4%;padding-right:1.5%;">
                    <div class="col-md-6" style="background:#782b55;min-height:620px;">
                        <div style="padding:8%;padding-bottom:0px;">
                        <h2 style="color:white;text-align:left;"> Activate Your PICKL {{planName}} {{numberOfPickls}} Plan</h2>
                        <h2 style="color:white;text-align:left;margin-bottom:2.8rem;margin-top:2.8rem;font-size:275%;"><strong>${{amount.toFixed(2)}}</strong> <small style="margin-left:4px;font-size:30px;color:white;display:inline-block;text-align:left">/ month*</small></h2>
                        <label style="font-size:20px;color:white;margin-botto:4px;"> {{numberOfPickls}} tasks/month</label><br/>

                        <label style="font-size:20px;color:white;margin-botto:4px;" v-if="planName== 'Essential'">Credits valid for 1 brand</label>
                        <label style="font-size:20px;color:white;margin-botto:4px;" v-if="planName== 'Supreme'">Share task credits/volume pricing<br/> with up to 2 partner brands</label>
                        <label style="font-size:20px;color:white;margin-botto:4px;" v-if="planName== 'Pro'"> Share task credits/volume pricing<br/> with up to 4 partner brands</label><br/>
                        <label style="font-size:20px;color:white;margin-bottom:4px">Monthly recurring plan</label><br/>
                        <label style="font-size:20px;color:white; " v-if="planName=='Pro'"> 2 Months cancellation notice</label>
                        <label style="font-size:20px;color:white;" v-if="planName=='Supreme'">2 Months cancellation notice</label>
                        <label style="font-size:20px;color:white; " v-if="planName=='Essential'">1 Month cancellation notice</label>
                        <label style="font-size:20px;color:white;">Unused credits rollover & expire <br/>30 days after final billing</label>
                        <br/><br/>
                        <label style="text-align:left;font-size:15px;color:white;">*Prices displayed in USD, based on 1 or 2 month cancellation policy per individual plan and monthly billing.</label>
                        </div>
                        <img src="/img/Brand New Features (1).png" style="margin-top:40px;width:105%;margin-left:-2.5%;"/><br/><br/>
                        <a class="Link Link--primary" href="https://stripe.com" target="_blank" rel="noopener" style="color:white;font-size:14px;text-decoration:none;">
                            <svg xmlns="http://www.w3.org/2000/svg" height="40" width="520" viewBox="-17.85 -6.5 154.7 39"><path d="M113 26H6c-3.314 0-6-2.686-6-6V6c0-3.314 2.686-6 6-6h107c3.314 0 6 2.686 6 6v14c0 3.314-2.686 6-6 6zM11.128 8.892H8.571v7.241h1.347v-2.6h1.21c1.474 0 2.526-.947 2.526-2.315 0-1.368-1.052-2.326-2.526-2.326zm5.915 1.853c-1.589 0-2.715 1.136-2.715 2.757 0 1.61 1.126 2.757 2.715 2.757s2.705-1.147 2.705-2.757c0-1.621-1.116-2.757-2.705-2.757zm9.893.126l-1.063 3.578-1.063-3.578h-1.22l-1.063 3.578-1.063-3.578h-1.347l1.81 5.262h1.21l1.063-3.578 1.074 3.578h1.21l1.799-5.262zm4.316-.126c-1.505 0-2.599 1.126-2.599 2.715 0 1.641 1.115 2.799 2.704 2.799.589 0 1.189-.137 1.789-.41v-1.127c-.547.316-1.084.495-1.568.495-.884 0-1.515-.547-1.6-1.347h3.568c.021-.179.021-.347.021-.495 0-1.546-.937-2.63-2.315-2.63zm6.472.052c-.147-.042-.294-.052-.442-.052-.452 0-.915.231-1.294.652v-.526h-1.347v5.262h1.347v-3.515c.347-.442.821-.684 1.263-.684.158 0 .326.021.473.063zm3.084-.052c-1.505 0-2.599 1.126-2.599 2.715 0 1.641 1.115 2.799 2.704 2.799.59 0 1.19-.137 1.789-.41v-1.127c-.547.316-1.083.495-1.568.495-.883 0-1.515-.547-1.599-1.347h3.567c.021-.179.021-.347.021-.495 0-1.546-.936-2.63-2.315-2.63zm8.104-2.179h-1.358v2.663c-.41-.316-.873-.484-1.336-.484-1.4 0-2.378 1.136-2.378 2.757 0 1.62.978 2.757 2.378 2.757.463 0 .926-.168 1.336-.495v.369h1.358zm6.778 2.179c-.452 0-.916.168-1.336.484V8.566h-1.347v7.567h1.347v-.369c.42.327.884.495 1.336.495 1.41 0 2.378-1.137 2.378-2.757 0-1.621-.968-2.757-2.378-2.757zm6.62.126l-1.273 3.452-1.263-3.452h-1.379l2.01 5.072-1.01 2.494H60.7l2.989-7.566zm10.799-.583c.863 0 1.96.264 2.824.731V8.344c-.941-.375-1.881-.519-2.822-.519-2.303 0-3.838 1.203-3.838 3.213 0 3.143 4.316 2.633 4.316 3.988 0 .525-.456.695-1.089.695-.941 0-2.155-.389-3.108-.907v2.711c1.056.454 2.126.644 3.105.644 2.361 0 3.988-1.166 3.988-3.21 0-3.386-4.341-2.778-4.341-4.056 0-.443.37-.615.965-.615zm9.071-2.274h-2.156l-.002-2.466-2.772.59-.013 9.109c0 1.681 1.265 2.922 2.95 2.922.928 0 1.614-.168 1.992-.376v-2.311c-.363.145-2.155.666-2.155-1.007v-4.04h2.156zm6.095.001c-.378-.136-1.705-.384-2.37.838l-.178-.839h-2.455v9.952h2.838v-6.747c.671-.881 1.804-.711 2.165-.594zm3.724-3.785l-2.85.606v2.313l2.85-.606zm0 3.784h-2.85v9.952h2.85zm6.126-.189c-1.113 0-1.832.524-2.224.89l-.148-.701h-2.5l.001 13.254 2.839-.604.006-3.213c.408.299 1.015.718 2.009.718 2.031 0 3.889-1.634 3.889-5.242 0-3.306-1.878-5.102-3.872-5.102zm8.924 0c-2.701 0-4.345 2.296-4.345 5.188 0 3.424 1.938 5.156 4.704 5.156 1.357 0 2.376-.308 3.147-.736v-2.287c-.774.39-1.662.628-2.789.628-1.107 0-2.082-.392-2.209-1.723h5.559c.013-.153.038-.748.038-1.023 0-2.908-1.408-5.203-4.105-5.203zm-.018 2.315c.697 0 1.437.537 1.437 1.815h-2.936c0-1.279.789-1.815 1.499-1.815zm-9.585 5.521c-.666 0-1.063-.24-1.339-.539l-.017-4.219c.296-.325.705-.563 1.356-.563 1.039 0 1.754 1.164 1.754 2.649 0 1.529-.704 2.672-1.754 2.672zm-42.04-.56c-.368 0-.737-.158-1.052-.473v-2.252c.315-.316.684-.474 1.052-.474.758 0 1.284.653 1.284 1.6 0 .947-.526 1.599-1.284 1.599zm-8.893 0c-.769 0-1.295-.652-1.295-1.599s.526-1.6 1.295-1.6c.368 0 .736.158 1.041.474v2.252c-.305.315-.673.473-1.041.473zm-5.757-3.315c.599 0 1.031.495 1.073 1.211h-2.294c.063-.726.568-1.211 1.221-1.211zm-9.557 0c.6 0 1.032.495 1.074 1.211h-2.295c.064-.726.569-1.211 1.221-1.211zm-14.156 3.347c-.789 0-1.336-.663-1.336-1.631s.547-1.631 1.336-1.631c.779 0 1.326.663 1.326 1.631s-.547 1.631-1.326 1.631zm-6.104-2.694H9.918V9.987h1.021c.779 0 1.326.495 1.326 1.231 0 .726-.547 1.221-1.326 1.221z" fill="#FFF" fill-rule="evenodd"/></svg>
                        </a>
                    </div>
                    <div class="col-md-6" style="padding:6%;">
                       <button
                            ref="popupCloseButton"
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        ></button>
                      <form v-on:submit.prevent="purchase" data-vv-scope="payment">
                        <h3>Enter Payment Information</h3><br/>
                        <input type="text" name="name" placeholder="Name on card" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('payment.name') }" style="height:40px;"/><br/>
                        <input type="text" name="email" placeholder="Email" style="height:40px;" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('payment.email') }"/><br/>
                        <div ref="card" style="margin-bottom: 20px; border: 1px solid #6f3053;height: 40px; padding: 2.5%;border-radius:2px;"></div>
                        <select name="country" style="margin-bottom:40px;" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('payment.country') }">
                            <option value="">Select country</option>
                            <option v-for="country in countries" :key="country.id" :value="country.id">{{country.name}}</option>
                        </select>
                        <button type="submit" class="btn-lg-green m0" :disabled="loading">ACTIVATE PLAN</button><br/>
                        <p style="text-align:left; color:gray;font-size:15px;margin-top:5px;width:100%;display:block;">By confirming your subscription, you allow PICKL to charge your card for this payment and future payments in accordance with their terms.</p>
                      </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// const plugin = document.createElement('script')
// plugin.setAttribute(
//   'src',
//   'https://js.stripe.com/v3/'
// )
// plugin.async = false
// document.head.appendChild(plugin)
// let stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY)
// let elements = stripe.elements()
// let card = ''
export default {
  props: ['amount', 'numberOfPickls', 'planName'],
  data () {
    return {
      loading: false,
      stripeAPIToken: process.env.VUE_APP_STRIPE_API_KEY,
      stripe: '',
      elements: '',
      card: '',
      countries: []
    }
  },
  mounted () {
    this.includeStripe()
    this.getCountries()
    // card = elements.create('card', style)
    // card.mount(this.$refs.card)
  },
  methods: {
    getCountries () {
      this.$http.get('countries?service_enabled=true').then((response) => {
        this.countries = response.body.data
      })
    },

    async includeStripe () {
      let documentTag = document
      let tag = 'script'
      let object = documentTag.createElement(tag)
      let scriptTag = documentTag.getElementsByTagName(tag)[0]
      object.src = 'https://js.stripe.com/v3/'
      scriptTag.parentNode.insertBefore(object, scriptTag)
      let v = this
      setTimeout(function () {
        v.configureStripe()
      }, 1000)
    },

    configureStripe () {
      let style = {
        base: {
          border: '1px solid #D8D8D8',
          borderRadius: '4px',
          color: '#000'
        }
      }
      this.stripe = Stripe(this.stripeAPIToken)
      this.elements = this.stripe.elements()
      this.card = this.elements.create('card', style)
      this.card.mount(this.$refs.card)
    },

    async purchase () {
      let result = await this.$validator.validateAll('payment').then((result) => {
        return result
      })
      if (result) {
        this.loading = true
        const self = this
        let response = await this.stripe.createToken(this.card).then(function (response) {
          return response
        })
        if (response.error) {
          this.$notify({ type: 'error', text: 'Error occured duing payment please refresh the page and try again' })
          this.loading = false
          return false
        }
        if (response.token) {
          this.$refs.popupCloseButton.click()
          this.$emit('paymentSuccessfull', response.token)
          this.loading = false
        }
      }
    }
  }

}
</script>
<style scoped>
select,
select:hover {
  border: 1px solid #6f3053;
  border-radius: 3px;
  margin-bottom: 20px;
  font-size: 18px;
  line-height: 20px;
  color: black;
  width: 100%;
  padding: 14px 42px 14px 16px;
  height: 50px;
  background-position: right 11px center;
  background-size: 20px 12px;
  background-image: url("/img/Create Pickl/selectproductDropdown_icon.png");
  background-color: white;
}
</style>
